<app-loading *ngIf="contentReady"></app-loading>

<div class="order-details-page" style="margin-bottom:100px;">

  <!-- TOP AREA -->
  <section class="order-details-top">
    <div class="order-details-appbar">
      <button class="order-details-appbar-btn" type="button" (click)="goBack()">
        <img [src]="isAr ? '/assets/e-commerce/icons/60.webp' : '/assets/e-commerce/icons/61.webp'" alt="back" />
      </button>

      <h1 class="order-details-appbar-title">{{ "order details" | transloco }}</h1>

      <div class="order-details-appbar-count">
        #{{ invoiceId }}
      </div>
    </div>
  </section>

  <!-- CONTENT -->
  <div class="order-details-content">

    <!-- STATUS CARD -->
    <section class="order-summary-card">
      @if(order_status != 3){

      <div class="order-summary-top">
        <div class="order-summary-main">
          <span class="order-summary-overline">{{ "order number" | transloco }}</span>
          <h2>#{{ invoiceId }}</h2>
          <p>{{ date }}</p>
        </div>

        <div class="order-summary-side">
          <span>{{ "total" | transloco }}</span>
          <strong>{{ total }} {{ "egpe" | transloco }}</strong>
        </div>
      </div>

      <div class="order-progress-card">
        <div class="progress-modern">
          <div class="progress-modern-step">
            <div class="progress-modern-circle" [class.active]="order_status == 1">1</div>
            <div class="progress-modern-label">{{ "pending" | transloco }}</div>
          </div>

          <div class="progress-modern-step">
            <div class="progress-modern-circle" [class.active]="order_status == 2">2</div>
            <div class="progress-modern-label">{{ "approved" | transloco }}</div>
          </div>

          <div class="progress-modern-step">
            <div class="progress-modern-circle" [class.active]="order_status == 4">3</div>
            <div class="progress-modern-label">{{ "withdelivery" | transloco }}</div>
          </div>

          <div class="progress-modern-step">
            <div class="progress-modern-circle" [class.active]="order_status == 5">4</div>
            <div class="progress-modern-label">{{ "shipped" | transloco }}</div>
          </div>
        </div>
      </div>

      } @else {
      <div class="order-cancelled-box">
        <img src="/assets/e-commerce/icons/69.webp" alt="product" class="order-cancelled-img">
        <p>{{ "canceled order" | transloco }}</p>
      </div>
      }
    </section>

    <!-- PRODUCTS -->
    <section class="order-section">
      <div class="order-section-header">
        <h3>{{ 'products' | transloco }}</h3>
      </div>

      <div class="order-products-list">
        <div class="order-product-card" *ngFor="let line of orderLines">
          <div class="order-product-row">

            <img class="order-product-image pointer" *ngIf="line.product?.image" (click)="openDetails(line.product)"
              [defaultImage]="'/assets/imageloading.gif'" [lazyLoad]="fixImage(line.product.image)"
              [errorImage]="'/assets/imageloading.gif'" alt="product" />

            <img class="order-product-image" *ngIf="!line.product?.image" src="/assets/imageloading.gif"
              alt="product" />

            <div class="order-product-content">
              <h4 class="order-product-title">
                @if(line.product){
                @if(isAr){
                {{ line.product.name_ar }}
                } @else {
                {{ line.product.name_en }}
                }
                } @else {
                {{ line.name }}
                }
              </h4>

              <div class="order-product-meta">
                <span class="order-qty-pill">
                  {{ 'quantity' | transloco }}: {{ line.qty }}
                </span>
              </div>

              <div class="order-price-row">
                <span class="order-new-price">
                  {{ line.price }} {{ "egpe" | transloco }}
                </span>

                @if(line.product && calcDis(line.price, line.product.pricec) != 0 && line.price > 0){
                <span class="order-old-price">
                  {{ line.product.pricec }} {{ "egpe" | transloco }}
                </span>
                }
              </div>

              <!-- Bundle Items -->
              <div class="order-bundle-box" *ngIf="line.product?.items?.length">
                <p class="order-bundle-title">
                  {{ "Show Bundle Items" | transloco }}
                </p>

                <div class="order-bundle-chip" *ngFor="let bItem of line.product.items">
                  <div class="order-bundle-chip-img">
                    <img [lazyLoad]="fixImage(bItem.stock.image)" />
                  </div>

                  <div class="order-bundle-chip-text">
                    <span class="order-bundle-chip-qty">×{{ bItem.quantity }}</span>
                    <span class="order-bundle-chip-name">
                      {{ isAr ? bItem.stock.name_ar : bItem.stock.name_en }}
                    </span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ORDER INFO -->
    <section class="order-section">
      <div class="order-section-header">
        <h3>{{ "details" | transloco }}</h3>
      </div>

      <div class="info-card-list">
        <div class="info-line">
          <span>{{ 'Date' | transloco }}</span>
          <strong>{{ date }}</strong>
        </div>

        <div class="info-line">
          <span>{{ "order number" | transloco }}</span>
          <strong>#{{ invoiceId }}</strong>
        </div>

        <div class="info-line info-line--address">
          <span>{{ "address" | transloco }}</span>
          <strong>{{ address }}</strong>
        </div>

        <div class="info-line">
          <span>{{ "subtotal" | transloco }}</span>
          <strong>{{ total - deliveryfees }} {{ "egpe" | transloco }}</strong>
        </div>

        <div class="info-line">
          <span>{{ "delivery fees" | transloco }}</span>
          <strong>{{ deliveryfees }} {{ "egpe" | transloco }}</strong>
        </div>

        <div class="info-line info-line--total">
          <span>{{ "total" | transloco }}</span>
          <strong>{{ total }} {{ "egpe" | transloco }}</strong>
        </div>
      </div>
    </section>

    <!-- MAP -->
    <section class="order-section">
      <div class="order-section-header">
        <h3>{{ 'Google Maps Link' | transloco }}</h3>
      </div>

      <div class="map-card">
        <app-maps [order_location]="order_location"></app-maps>
      </div>
    </section>

  </div>
</div>